export default function Scroll($timeout) {
    var fn = this;

    fn.to = function (elemID, offset) {
        // $timeout(() => {
        //     console.log("Scroll.to", elemID, offset);
        //     window.scrollTo({
        //         top: 0,
        //         behavior: "smooth",
        //     });
        // }, 500);
        // return;

        $timeout(() => {
            const element = document.getElementById(elemID);

            const y =
                element.getBoundingClientRect().top -
                offset +
                document.documentElement.scrollTop;

            window.scrollTo({
                top: y,
                behavior: "smooth",
            });

            element.focus({ preventScroll: true }); // Set focus on element (doing this will prevent Skip Links from having focus on route change)
        }, 800);
    };

    return fn;
}
